import "../src/easy_legacy_js/easy_page";

window.EasyVue ||= {};
window.EasyVue.editPageTabTranslations = async (tabTranslationsOptions, confirmText) => {
  const { editPageTabTranslations } = await import("../src/easy_page/utils/editPageTabTranslations");

  window.EasyVue.editPageTabTranslations = editPageTabTranslations;

  return editPageTabTranslations(tabTranslationsOptions, confirmText);
};
